export default __webpack_public_path__ + "static/media/merchant-image.e7ca3fe4.png";